import { render, staticRenderFns } from "./ModalExpenseCategory.vue?vue&type=template&id=0bf28808"
import script from "./ModalExpenseCategory.vue?vue&type=script&lang=js"
export * from "./ModalExpenseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports